<app-header></app-header>
<div class="video-container">
    <canvas id="three-canvas"></canvas>
    <video id="video" autoplay playsinline muted>
    </video>
    
</div>